import * as React from 'react';



const NoteSummary = (({data})=>(
        <span>{data.NoteSummary}</span>
));

export default NoteSummary;